module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "gs-header"
  }, [_c('h2', [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(page, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": page.route
      }
    }, [_vm._v(_vm._s(page.title))])
  }), _vm._v(" "), (_vm.title) ? _c('el-breadcrumb-item', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e8bda89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/GsHeader.vue
// module id = 639
// module chunks = 1